/* global $ */
/**
 * Maintain all checkout related custom forms' validation.
 * Extends jquery.shopgate-ajax-forms.js
 *
 */
import SGDHLPackstation from './shopgate-dhl-packstation';

;(function () {
  $.fn.shopgateFormHelpers = function (_options) {
    const defaults = {
      classes: {
        invoiceAddressToggle: '.invoice-address-toggle',
        invoiceAddressWrapper: '.invoice-address-wrapper',
        countryStateWrapper: '.country-state-wrapper',
        countryList: '.country-list select',
        stateList: '.state-list',
        specificStateListPattern: 'states-',
      },
    };

    let options = _options || {};
    options = $.extend({}, defaults, options);

    function setupCountryListEvents(index, wrapper) {
      const countryList = $(wrapper).find(options.classes.countryList);
      const stateLists = $(wrapper).find(options.classes.stateList);

      /**
       * Passt die Staatenlisten an das gewaehlte Land an
       */
      function updateStateLists() {
        const selectedCountryId = countryList.val();

        // Verstecke erst alle Staatenlisten und zeige passende an, wenn gefunden
        stateLists
          .hide()
          .filter(function () {
            return $(this).data('country-key') === selectedCountryId;
          })
          .show();
      }

      // initiales Update der Staaten
      updateStateLists();

      // Event fuer den Laenderwechsel
      countryList.change(updateStateLists);
    }

    function setupToggleInvoiceAdress(that) {
      const toggle = that.find(options.classes.invoiceAddressToggle);
      const wrapper = that.find(options.classes.invoiceAddressWrapper);

      function toggleInvoiceAddress(e) {
        if (toggle.attr('readonly')) {
          e.preventDefault();
          return false;
        }

        const state = toggle.prop('checked');
        wrapper.toggle(state);
        $(this)
          .parent('.checkbox-element')
          .toggleClass('checked', state);

        return true;
      }

      toggleInvoiceAddress();
      toggle.click(toggleInvoiceAddress);
    }

    return this.each(function () {
      const that = $(this);
      const packstation = that.find(SGDHLPackstation.packstationToggleSelector);
      const countryStateWrapper = that.find(options.classes.countryStateWrapper);

      setupToggleInvoiceAdress(that);

      countryStateWrapper.each(setupCountryListEvents);

      if (packstation.length) {
        SGDHLPackstation.init(that, $(that).find(options.classes.countryList).first());
      }
    });
  };

  if (typeof window.layoutFeatures === 'undefined' || !window.layoutFeatures.checkoutNew) {
    /**
     * Contains the logic to deal with payment methods forms
     * @returns {jQuery} element
     */
    $.fn.shopgateAjaxFormTypePayment = function () {
      return this.each(function () {
        const that = $(this);
        const customPaymentMethodEntriesWrapper = that.parentsUntil('.payment-form').parent();
        const customPaymentMethodFormPanel = that.find('.panel-collapse');

        // reset the form if its collapsed
        customPaymentMethodFormPanel.on('hidden.bs.collapse', () => {
          that.trigger('reset');
        });

        /**
         * This event is triggered when the repsonse data of an ajax request arrived
         * @param {Object} An JS event object
         * @param {Object} The ajax response
         */
        that.bind('shopgateFramework.forms.dataUpdate', (e, data) => {
          const lastPaymentMethodEntry = customPaymentMethodEntriesWrapper
            .children('.form-group')
            .last();
          const termsConfirmationWrapper = customPaymentMethodEntriesWrapper
            .find('.terms-confirmation-wrapper');

          // the form submit was successful and we have html markup
          if (data.success && data.html) {
            // get the new entry from the response data
            const newPaymentMethodEntry = $(data.html).hide();

            // insert the new payment method at the end of the payment methods list
            if (lastPaymentMethodEntry.length > 0) {
              newPaymentMethodEntry.insertAfter(lastPaymentMethodEntry);
            } else {
              if (termsConfirmationWrapper.length) {
                newPaymentMethodEntry.insertAfter(termsConfirmationWrapper);
              } else {
                customPaymentMethodEntriesWrapper.prepend(newPaymentMethodEntry);
              }
            }

            // show the new entry
            newPaymentMethodEntry.slideDown();

            // hide the form
            customPaymentMethodFormPanel.collapse('hide');
            customPaymentMethodEntriesWrapper
              .find(`a[href="#${customPaymentMethodFormPanel.prop('id')}"]`)
              .addClass('collapsed');

            // inform the scripts that a new custom payment method was added
            $(document).trigger('shopgateFramework.forms.payment.customPaymentMethodAdded', [
              newPaymentMethodEntry,
            ]);
          }
        });
      });
    };

    /**
     * Contains the logic to deal with invoice address forms
     * @returns {jQuery} element
     */
    $.fn.shopgateAjaxFormTypeInvoiceAddress = function () {
      return this.each(function () {
        const that = $(this);
        const invoiceAddressEntriesWrapper = that.parentsUntil('.address-wrapper').parent();
        const invoiceAddressFormPanel = that.find('.panel-collapse');

        // reset the form if its collapsed
        invoiceAddressFormPanel.on('hidden.bs.collapse', () => {
          that.trigger('reset');
        });

        /**
         * This event is triggered when the repsonse data of an ajax request arrived
         * @param {Object} An JS event object
         * @param {Object} The ajax response
         */
        that.bind('shopgateFramework.forms.dataUpdate', (e, data) => {
          const lastInvoiceAddress = invoiceAddressEntriesWrapper.children('.form-group').last();

          // the form submit was successful and we have html markup
          if (data.success && data.html) {
            // get the new entry from the response data
            const newInvoiceAddress = $(data.html).hide();

            // insert the new payment method at the end of the payment methods list
            if (lastInvoiceAddress.length > 0) {
              newInvoiceAddress.insertAfter(lastInvoiceAddress);
            } else {
              invoiceAddressEntriesWrapper.prepend(newInvoiceAddress);
            }

            // show the new entry
            newInvoiceAddress.slideDown();

            // hide the form
            invoiceAddressFormPanel.collapse('hide');
            invoiceAddressEntriesWrapper
              .find(`a[href="#${invoiceAddressFormPanel.prop('id')}"]`)
              .addClass('collapsed');

            // inform the scripts that a new custom payment method was added
            $(document).trigger('shopgateFramework.forms.addresses.invoiceAddressAdded', [
              newInvoiceAddress,
            ]);
          }
        });
      });
    };

    /**
     * Contains the logic to deal with invoice address forms
     * @returns {jQuery} element
     */
    $.fn.shopgateAjaxFormTypeShippingAddress = function () {
      return this.each(function () {
        const that = $(this);
        const shippingAddressEntriesWrapper = that
          .closest('.address.container')
          .find('.shipping-address-container');
        const shippingAddressFormPanel = that.find('.panel-collapse');

        // reset the form if its collapsed
        shippingAddressFormPanel.on('hidden.bs.collapse', () => {
          that.trigger('reset');
          that.find('#newAdress').hide();
        });

        /**
         * This event is triggered when the repsonse data of an ajax request arrived
         * @param {Object} An JS event object
         * @param {Object} The ajax response
         */
        that.bind('shopgateFramework.forms.dataUpdate', (e, data) => {
          const lastShippingAddress = shippingAddressEntriesWrapper.children('.form-group').last();

          // the form submit was successful and we have html markup
          if (data.success && data.html) {
            // get the new entry from the response data
            const newShippingAddress = $(data.html).hide();

            // insert the new shipping address at the end of the shippimng addresses list
            if (lastShippingAddress.length > 0) {
              newShippingAddress.insertAfter(lastShippingAddress);
            } else {
              shippingAddressEntriesWrapper.prepend(newShippingAddress);
            }

            newShippingAddress
              .find('form')
              .shopgateFormHelpers()
              .shopgateAjaxFormSubmit()
              .shopgateAjaxFormValidationDefault()
              .shopgateAjaxFormTypeInvoiceAddress();

            // show the new entry
            newShippingAddress.slideDown();

            // hide the form
            shippingAddressFormPanel.collapse('hide');

            shippingAddressEntriesWrapper
              .find(`a[href="#${shippingAddressFormPanel.prop('id')}"]`)
              .addClass('collapsed');

            // inform the scripts that a new custom payment method was added
            $(document).trigger('shopgateFramework.forms.addresses.shippingAddressAdded', [
              newShippingAddress,
            ]);
          }
        });
      });
    };

    $.fn.shopgatePaymentManagement = function (_options) {
      const defaults = {
        urlChangePaymentMethod: 'user_change_payment_method',
        urlDeletePaymentMethod: 'user_delete_payment_method',
      };

      let options = _options || {};
      options = $.extend({}, defaults, options);

      return this.each(function () {
        const that = $(this);
        let termsCheckboxes = null;

        /**
         * performs payment delete
         * @param {Object} _currentPaymentMethodElement The dom element that represents the
         * currently selected payment method
         */
        function performDefaultPaymentDeleteRequest(_currentPaymentMethodElement) {
          const currentPaymentMethodElement = _currentPaymentMethodElement || $();

          const paymentDeleteUrlParams = [options.urlDeletePaymentMethod, 0, 0, 1];

          function onBeforePaymentDelete() {
            termsCheckboxes.trigger('disable', [true]);
            currentPaymentMethodElement
              .trigger('shopgateFramework.forms.payment.paymentMethodChangePending');
          }

          function onCompletePaymentDelete() {
            termsCheckboxes.trigger('disable', [false]);
            currentPaymentMethodElement
              .trigger('shopgateFramework.forms.payment.paymentMethodChangeComplete');
          }

          function onErrorPaymentDelete() {
          }

          function onSuccessPaymentDelete(data) {
            if (data.success) {
              // remove all checkedmarks if the deletion operation was successful
              that.find('.payment-label').removeClass('checked');
            }
          }

          $.shopgate.ajax({
            url: paymentDeleteUrlParams.join('/'),
            beforeSend: onBeforePaymentDelete,
            complete: onCompletePaymentDelete,
            error: onErrorPaymentDelete,
            success: onSuccessPaymentDelete,
          });
        }

        function performPaymentDeleteRequest(
          currentPaymentMethod, paymentMethodGroupId, paymentId
        ) {
          // prepare the request url
          const paymentDeleteUrlParams = [options.urlDeletePaymentMethod];
          const paymentMethodForm = currentPaymentMethod.parentsUntil('.payment-form').parent();
          const paymentMethodCreationPanel = paymentMethodForm.find('.panel-collapse');

          if (paymentMethodGroupId) {
            paymentDeleteUrlParams.push(paymentMethodGroupId);

            if (paymentId) {
              paymentDeleteUrlParams.push(paymentId);
            }
          }

          // no params collected. so we stop the process
          if (paymentDeleteUrlParams.length <= 1) {
            return false;
          }

          function onSuccessPaymentDelete(data) {
            // send an event to update the select status
            if (data.success) {
              const siblingCounter = currentPaymentMethod.parent().siblings('.form-group').length;

              currentPaymentMethod.parent().slideUp(function () {
                $(this).remove();

                if (siblingCounter === 0) {
                  paymentMethodCreationPanel.collapse('show');
                  paymentMethodForm
                    .find(`a[href="#${paymentMethodCreationPanel.prop('id')}"]`)
                    .removeClass('collapsed');
                }
              });
            }
          }

          $.shopgate.ajax({
            url: paymentDeleteUrlParams.join('/'),
            success: onSuccessPaymentDelete,
          });
          return true;
        }

        function setupPaymentDeleteListeners() {
          // get all current delete buttons
          const paymentDeleteButtons = that.find('.btn-delete');

          paymentDeleteButtons.unbind('click').bind('click', function (e) {
            e.preventDefault();
            e.stopPropagation();

            const currentPaymentMethod = $(this).parent('[data-payment-group-id]');

            performPaymentDeleteRequest(
              currentPaymentMethod,
              currentPaymentMethod.data('paymentGroupId'),
              currentPaymentMethod.data('paymentId')
            );
          });
        }

        /**
         * Starts a new request to change the default payment method
         * @param {jQuery} el Element
         * @param {string} paymentMethodGroupId Payment method group id
         * @param {number} paymentId payment method id
         */
        function performPaymentChangeRequest(el, paymentMethodGroupId, paymentId) {
          // prepare the request url
          const paymentChangeUrlParams = [options.urlChangePaymentMethod];

          if (paymentMethodGroupId) {
            paymentChangeUrlParams.push(paymentMethodGroupId);

            if (paymentId) {
              paymentChangeUrlParams.push(paymentId);
            }
          }

          // no params collected. so we stop the process
          if (paymentChangeUrlParams.length <= 1) {
            return;
          }

          function onBeforePaymentChange() {
            termsCheckboxes.trigger('disable', [true]);
            el.trigger('shopgateFramework.forms.payment.paymentMethodChangePending');
          }

          function onCompletePaymentChange() {
            termsCheckboxes.trigger('disable', [false]);
            el.trigger('shopgateFramework.forms.payment.paymentMethodChangeComplete');
          }

          function onErrorPaymentChange() {
          }

          function onSuccessPaymentChange(data) {
            // send an event to update the select status
            if (data.success) {
              let paymentMethodCheckbox = null;
              let relevantTermsCheckboxes = termsCheckboxes;

              if (el.data('paymentId')) {
                paymentMethodCheckbox = el
                  .closest('.payment-form')
                  .find(':checkbox.terms-confirmation');
              } else {
                paymentMethodCheckbox = el.find(':checkbox.terms-confirmation');
              }

              if (paymentMethodCheckbox && paymentMethodCheckbox.length) {
                relevantTermsCheckboxes = termsCheckboxes.not(paymentMethodCheckbox);
              }

              relevantTermsCheckboxes.trigger('updateState', [false]);
              el.trigger('shopgateFramework.forms.payment.paymentMethodChanged');
            }
          }

          $.shopgate.ajax({
            url: paymentChangeUrlParams.join('/'),
            beforeSend: onBeforePaymentChange,
            complete: onCompletePaymentChange,
            error: onErrorPaymentChange,
            success: onSuccessPaymentChange,
          });
        }

        function setupPaymentChangeListeners(paymentMethodGroupId, paymentId) {
          // get all current selectable payment method entries
          const paymentMethods = $('.payment-selector');

          if (paymentMethodGroupId && paymentId) {
            const excludedPaymentMethod =
                    that
                      .find(`[data-payment-group-id="${paymentMethodGroupId}"][data-payment-id="${paymentId}]"`);
            paymentMethods.not(excludedPaymentMethod).removeClass('checked');
          }

          paymentMethods.each(function () {
            // simple payment methods that contain a terms confirmation are
            // not activated by clicking on the payment
            // method element but by accepting the terms confirmation
            const termsConfirmation = $(this).data('termsConfirmation') ? true : false;

            $(this).unbind('click').bind('click', function(e) {
              const $that = $(this);

              // Spare the request if this payment method is already selected. Additionally
              // links within the payment method description shouldn't trigger a selection.
              if ($that.hasClass('checked') || e.target.tagName === 'A') {
                return;
              }

              // send request only if payment group id is set
              if ($that.data('payment-group-id') && !termsConfirmation) {
                // start the request
                performPaymentChangeRequest(
                  $that,
                  $that.data('paymentGroupId'),
                  $that.data('paymentId')
                );
              } else {
                $that.trigger('shopgateFramework.forms.payment.paymentMethodChanged');
              }
            });
          });
        }

        function setupTermsCheckboxes() {
          termsCheckboxes = that.find(':checkbox.terms-confirmation').shopgateUICheckbox();

          termsCheckboxes.each(function () {
            const currentCheckbox = $(this);
            const methodParentFormGroup = currentCheckbox.closest('.form-group');
            const paymentMethodElement = methodParentFormGroup.children(':first');
            let isPaymentMethodWithForm = null;
            let checkboxHitArea = null;

            /**
             * Toggles the elements that are used to create / select a concrete payment method
             * @param {boolean} show - to show it or not
             */
            function toggleFormMethodElements(show) {
              methodParentFormGroup.find('.form-group, .panel').toggle(show);

              if (show) {
                // unhide not selected mayment method entries
                methodParentFormGroup.find('.payment-label').removeClass('hidden');
              }
            }

            // check the type of the payment method the checkbox belongs to
            if (paymentMethodElement.hasClass('payment-form-label')) {
              isPaymentMethodWithForm = true;
            } else if (paymentMethodElement.hasClass('payment-label')) {
              isPaymentMethodWithForm = false;
            }

            // init the checkboxes
            toggleFormMethodElements(currentCheckbox.is(':checked'));

            if (!isPaymentMethodWithForm) {
              checkboxHitArea = paymentMethodElement;
            } else {
              checkboxHitArea = methodParentFormGroup.find('.terms-text');
            }

            // any click on hit area toggles the checkbox - except the terms links
            checkboxHitArea.bind('click', (e) => {
              if (e.target.tagName !== 'A') {
                currentCheckbox.trigger('click');
              }
            });

            currentCheckbox.bind('onChange', (e, checkbox, manual) => {
              const isChecked = checkbox.is(':checked');

              if (manual) {
                // logic if the user interacted with the checkbox
                if (isPaymentMethodWithForm === false) {
                  // simple pament method
                  if (isChecked) {
                    // if the terms are accepted SELECT the payment method
                    performPaymentChangeRequest(
                      paymentMethodElement,
                      paymentMethodElement.data('paymentGroupId')
                    );
                  } else {
                    // if the terms confirmation was cancelled REMOVE the selection
                    performDefaultPaymentDeleteRequest(paymentMethodElement);
                  }
                } else if (isPaymentMethodWithForm === true) {
                  // payment method with form
                  if (isChecked) {
                    // show the payment methods / payment method creation form
                    toggleFormMethodElements(true);
                  } else {
                    // hide the payment methods / payment method creation form
                    toggleFormMethodElements(false);

                    // if the current form payment type has a selected payment method -> delete it
                    if (methodParentFormGroup.find('.payment-label.checked').length) {
                      performDefaultPaymentDeleteRequest(paymentMethodElement);
                    }
                  }
                }
              } else {
                // logic if the checkbox state changed by the script
                if (isPaymentMethodWithForm === true) {
                  toggleFormMethodElements(false);
                }
              }
            });
          });
        }

        setupTermsCheckboxes();
        setupPaymentChangeListeners();
        setupPaymentDeleteListeners();

        // add new event listeners to new custom payment methods
        $(document).bind('shopgateFramework.forms.payment.customPaymentMethodAdded', (e, newPaymentMethodEntry) => {
          let addedPaymentMethodGroupId = null;
          let addedPaymentId = null;
          const newPaymentMethodEntryDataElement =
                  newPaymentMethodEntry ? newPaymentMethodEntry.find('[data-payment-group-id]') : [];

          if (newPaymentMethodEntryDataElement.length > 0) {
            addedPaymentMethodGroupId = newPaymentMethodEntryDataElement.data('paymentGroupId');
            if (newPaymentMethodEntryDataElement.data('paymentId')) {
              addedPaymentId = newPaymentMethodEntryDataElement.data('paymentId');
            }
          }

          setupPaymentChangeListeners(addedPaymentMethodGroupId, addedPaymentId);
          setupPaymentDeleteListeners();
        });
      });
    };

    $.fn.shopgateShippingManagement = function (_options) {
      const defaults = {
        urlChangeShippingtMethod: 'user_change_shipping_method',
      };

      let options = _options || {};
      options = $.extend({}, defaults, options);

      return this.each(function () {
        const that = $(this);

        function performShippingChangeRequest(el, shippingServiceId) {
          // prepare the request url
          const shippingChangeUrlParams = [options.urlChangeShippingtMethod];

          if (shippingServiceId) {
            shippingChangeUrlParams.push(shippingServiceId);
          }

          // no params collected. so we stop the process
          if (shippingServiceId.length <= 1) {
            return;
          }

          function onBeforePaymentChange() {
            el.trigger('shopgateFramework.forms.shipping.shippingMethodChangePending');
          }

          function onCompletePaymentChange() {
            el.trigger('shopgateFramework.forms.shipping.shippingMethodChangeComplete');
          }

          function onSuccessPaymentChange(data) {
            // send an event to update the select status
            if (data.success) {
              el.trigger('shopgateFramework.forms.shipping.shippingMethodChanged');
            }
          }

          $.shopgate.ajax({
            url: shippingChangeUrlParams.join('/'),
            beforeSend: onBeforePaymentChange,
            complete: onCompletePaymentChange,
            success: onSuccessPaymentChange,
          });
        }

        function setupShippingChangeListeners() {
          // get all current selectable shipping service entries
          const shippingServices = that.find('[data-shipping-service-id]');

          // unbind old listeners and bind new
          shippingServices.unbind('click').bind('click', function() {
            const $that = $(this);
            // spare the request of this invoice address is already selected
            if ($that.hasClass('checked')) {
              return;
            }
            // start the request
            performShippingChangeRequest($that, $that.data('shippingServiceId'));
          });
        }

        setupShippingChangeListeners();
      });
    };

    $.fn.shopgateAddressManagement = function (_options) {
      const defaults = {
        urlChangeInvoiceAddress: '',
        urlDeleteAddress: '',
      };

      let options = _options || {};
      options = $.extend({}, defaults, options);

      return this.each(function () {
        const that = $(this);
        const addressDataApplyWrapper = $('#apply-address-data');
        let shippingAddressCreationPanel = $('#collapse-new-shipping-address')
          .bind('show.bs.collapse', () => {
            addressDataApplyWrapper.hide();
          }).bind('hide.bs.collapse', () => {
            addressDataApplyWrapper.show();
          });

        function checkApplyButton() {
          const shippingAddresses = that.find('.shipping-address-container').children();

          if (shippingAddresses.length === 0) {
            $('#apply-address-data').hide();
          } else {
            $('#apply-address-data').show();
          }
        }

        function performAddressDeleteRequest(currentAddress, addressId, isInvoiceAddress) {
          // prepare the request url
          const addressDeleteUrlParams = [options.urlDeleteAddress];
          let invoiceAddressCreationPanel;
          let invoiceAddressForm;
          let shippingAddressForm;

          if (isInvoiceAddress) {
            invoiceAddressForm = currentAddress.parentsUntil('.payment-form').parent();
            invoiceAddressCreationPanel = invoiceAddressForm.find('.panel-collapse');
          } else {
            shippingAddressForm = currentAddress.closest('.address.container');
            shippingAddressCreationPanel = shippingAddressForm
              .find('.panel form .panel-collapse');
          }

          // prepare the url
          if (addressId) {
            addressDeleteUrlParams.push(addressId);
          }

          // no params collected. so we stop the process
          if (addressDeleteUrlParams.length !== 2) {
            return;
          }

          function onSuccessAddressDelete(data) {
            // send an event to update the select status
            if (data.success) {
              const siblingCounter = currentAddress.parent().siblings('.form-group').length;
              const defaultAddressIds = data.data.default_address_ids ?
                data.data.default_address_ids : null;
              const defaultShippingAddressId = defaultAddressIds.shipping_address_id ?
                defaultAddressIds.shipping_address_id : null;
              const defaultInvoiceAddressId = defaultAddressIds.invoice_address_id ?
                defaultAddressIds.invoice_address_id : null;

              // remove the old default flags
              that.find('.address-selector').removeClass('checked');

              // flag the new default addresses
              if (defaultShippingAddressId) {
                that.find(`.address-selector.shipping-address[data-shipping-address-id="${defaultShippingAddressId}"]`)
                  .addClass('checked');
              }

              if (defaultInvoiceAddressId) {
                that.find(`.address-selector.invoice-address[data-invoice-address-id="${defaultInvoiceAddressId}"]`)
                  .addClass('checked');
              }

              currentAddress.parent().slideUp(function () {
                if (siblingCounter === 0) {
                  if (isInvoiceAddress) {
                    $(this)
                      .closest('.payment-form')
                      .find('.no-invoice-address-alert')
                      .removeClass('hidden');
                    invoiceAddressCreationPanel.collapse('show');
                    invoiceAddressForm
                      .find(`a[href="#${invoiceAddressCreationPanel.prop('id')}"]`)
                      .removeClass('collapsed');
                  } else {
                    $(this)
                      .closest('.address.container')
                      .find('.no-shipping-address-alert')
                      .removeClass('hidden');
                    shippingAddressCreationPanel.collapse('show');
                    shippingAddressForm
                      .find(`a[href="#${shippingAddressCreationPanel.prop('id')}"]`)
                      .removeClass('collapsed');
                  }
                } else {
                  if (isInvoiceAddress) {
                    $(this).closest('.payment-form')
                      .find('.no-invoice-address-alert')
                      .addClass('hidden');
                  } else {
                    $(this).closest('.address.container')
                      .find('.no-shipping-address-alert')
                      .addClass('hidden');
                  }
                }

                $(this).remove();

                checkApplyButton();
              });
            }
          }

          $.shopgate.ajax({
            url: addressDeleteUrlParams.join('/'),
            success: onSuccessAddressDelete,
          });
        }

        function setupAddressDeleteListeners() {
          // get all current delete buttons
          const addressDeleteButtons = that.find('.btn-delete');

          // delete process for invoice addresses
          addressDeleteButtons.unbind('click').bind('click', function (e) {
            e.preventDefault();
            e.stopPropagation();

            if ($(this).hasClass('invoice-address')) {
              const currentInvoiceAddress = $(this).parent('[data-invoice-address-id]');
              performAddressDeleteRequest(
                currentInvoiceAddress,
                currentInvoiceAddress.data('invoiceAddressId'),
                true
              );
            } else if ($(this).hasClass('shipping-address')) {
              const currentShippingAddress = $(this).parent('[data-shipping-address-id]');
              performAddressDeleteRequest(
                currentShippingAddress,
                currentShippingAddress.data('shippingAddressId'),
                false
              );
            }
          });
        }

        /**
         * Starts a new request to change the default invoice address
         * @param {jQuery} el Element
         * @param {number} shippingAddressId Address id
         * @param {number} invoiceAddressId Address id
         */
        function performPaymentChangeRequest(el, shippingAddressId, invoiceAddressId) {
          // prepare the request url
          const invoiceAddressChangeUrlParams = [options.urlChangeInvoiceAddress];

          if (shippingAddressId) {
            invoiceAddressChangeUrlParams.push(shippingAddressId);

            if (invoiceAddressId) {
              invoiceAddressChangeUrlParams.push(invoiceAddressId);
            }
          }

          // no params collected. so we stop the process
          if (invoiceAddressChangeUrlParams.length !== 3) {
            return;
          }

          function onBeforeInvoiceAddressChange() {
            el.trigger('shopgateFramework.forms.adddress.addressChangePending');
          }

          function onCompleteInvoiceAddressChange() {
            el.trigger('shopgateFramework.forms.adddress.addressChangeComplete');
          }

          function onSuccessInvoiceAddressChange(data) {
            // send an event to update the select status
            if (data.success) {
              el.trigger('shopgateFramework.forms.adddress.addressChanged');
            }
          }

          $.shopgate.ajax({
            url: invoiceAddressChangeUrlParams.join('/'),
            beforeSend: onBeforeInvoiceAddressChange,
            complete: onCompleteInvoiceAddressChange,
            success: onSuccessInvoiceAddressChange,
          });
        }

        function setupInvoiceAddressChangeListeners(shippingAddressId, invoiceAddressId) {
          // get all current selectable invoice addresses
          const invoiceAddresses = that.find('[data-invoice-address-id]');

          if (shippingAddressId && invoiceAddressId) {
            const excludedInvoiceAddress = that.find(`[data-shipping-address-id="${shippingAddressId}"][data-invoice-address-id="${invoiceAddressId}"]`);
            invoiceAddresses.not(excludedInvoiceAddress).removeClass('checked');
          }

          // unbind old listeners and bind new
          invoiceAddresses.unbind('click').bind('click', function () {
            const $that = $(this);
            // spare the request of this invoice address is already selected
            if ($that.hasClass('checked')) {
              return;
            }

            // start the request
            performPaymentChangeRequest(
              $that,
              $that.data('shippingAddressId'),
              $that.data('invoiceAddressId')
            );
          });
        }

        setupInvoiceAddressChangeListeners();
        setupAddressDeleteListeners();
        checkApplyButton();

        // add new event listeners to the new invoice address
        $(document).bind('shopgateFramework.forms.addresses.invoiceAddressAdded', (e, newInvoiceAddress) => {
          let addedShippingAddressId = null;
          let addedInvoiceAddressId = null;
          const newInvoiceAddressDataElement = newInvoiceAddress ?
            newInvoiceAddress.find('[data-invoice-address-id]') : [];

          if (newInvoiceAddressDataElement.length > 0) {
            addedShippingAddressId = newInvoiceAddressDataElement.data('shippingAddressId');
            if (newInvoiceAddressDataElement.data('invoiceAddressId')) {
              addedInvoiceAddressId = newInvoiceAddressDataElement.data('invoiceAddressId');
            }

            newInvoiceAddressDataElement
              .closest('.payment-form')
              .find('.no-invoice-address-alert')
              .addClass('hidden');
          }

          setupInvoiceAddressChangeListeners(addedShippingAddressId, addedInvoiceAddressId);
          setupAddressDeleteListeners();
        });

        // add new event listeners to the new shipping address
        $(document).bind('shopgateFramework.forms.addresses.shippingAddressAdded', (e, newShippingAddress) => {
          let addedShippingAddressId = null;
          const newShippingAddressDataElement = newShippingAddress ?
            newShippingAddress.find('.shipping-address[data-shipping-address-id]') : [];

          if (newShippingAddressDataElement.length > 0) {
            addedShippingAddressId = newShippingAddressDataElement.data('shippingAddressId');
          }

          newShippingAddressDataElement
            .closest('.address.container')
            .find('.no-shipping-address-alert')
            .addClass('hidden');

          setupAddressDeleteListeners();
          checkApplyButton();
        });
      });
    };
  }

  /**
   * Contains the logic to deal with invoice address forms
   * @returns {jQuery} Elements
   */
  $.fn.shopgateAjaxFormTypeCheckout = function () {
    return this.each(function () {
      const currentForm = $(this);
      const cvcCodeField = currentForm.find('#userCvcCode');
      const submitButton = currentForm.find('button[type=submit]');
      const submitTopButton = currentForm.find('button.checkout-top-button');
      const extraFields = currentForm.find('.extra-fields');
      const birthdayFields = currentForm.find('.birthday-fields');
      const phoneFields = currentForm.find('.phone-fields');
      // this whole validation scripts should be refactored some day
      const otherRequiredFields = currentForm.find('.required-field');
      let submitPossible = false;
      let cvcCorrectLength = true;
      let keyupTimeout;
      let validationTimeout = null;
      let throttled = false;

      function checkCvcCode() {
        let lockSubmit = true;
        if (cvcCodeField.length === 0) {
          return lockSubmit;
        }

        if (cvcCodeField.val().length > 2) {
          cvcCodeField.closest('.order-label').removeClass('has-error');
          cvcCodeField.closest('.input-group').removeClass('has-error');
          cvcCodeField.closest('.form-group').removeClass('has-error');

          lockSubmit = false;
          cvcCorrectLength = true;
        } else {
          cvcCodeField.closest('.order-label').addClass('has-error');
          cvcCodeField.closest('.input-group').addClass('has-error');
          cvcCodeField.closest('.form-group').addClass('has-error');

          cvcCorrectLength = false;
        }

        return lockSubmit;
      }

      function checkRequiredInputs() {
        let allOK = true;
        $.each(otherRequiredFields, function () {
          const inputType = $(this).attr('type');
          let value;

          if (inputType === 'radio') {
            const inputName = $(this).attr('name');
            const inputRadioChecked = $(`input[name="${inputName}"]:checked`);
            if (inputRadioChecked.length < 1) {
              value = '';
            } else {
              value = $(`input[name="${inputName}"]:checked`).val();
            }
          } else {
            value = $(this).val();
          }

          if (value.length < 1) {
            $(this).closest('.form-group').addClass('has-error');
            allOK = false;
          } else {
            const $formGroup = $(this).closest('.form-group');

            if ($('.help-block', $formGroup).length === 0) {
              // Only remove the error class, if there is no help-block left
              $formGroup.removeClass('has-error');
            }
          }
        });

        return allOK;
      }

      function lockSubmitButton(lock) {
        if (lock) {
          currentForm.data({ submitDisabled: true });
          submitButton.addClass('locked btn-no-loading');
          submitButton.removeClass('loading');
          submitTopButton.addClass('hidden');
          submitPossible = false;
        } else {
          currentForm.data({ submitDisabled: false });
          submitButton.removeClass('locked btn-no-loading');
          submitTopButton.removeClass('hidden');
          submitPossible = true;
        }
      }

      function checkSubmitButtonStatus() {
        checkCvcCode();

        // Execute the input check. It also adds the right error classes to the form elements.
        checkRequiredInputs();

        if (
          currentForm.find('.has-error:visible, .alert:visible').length > 0
          || !cvcCorrectLength
        ) {
          lockSubmitButton(true);
        } else {
          lockSubmitButton(false);
        }
      }

      function removeError(e, _targetElement) {
        const targetElement = _targetElement || $(this);
        const formGroup = targetElement.closest('.form-group');

        if (formGroup.hasClass('has-error')) {
          formGroup.removeClass('has-error').find('.help-block').remove();
        }
        clearInterval(keyupTimeout);
        keyupTimeout = setTimeout(() => {
          checkSubmitButtonStatus();
        }, 300);
      }

      submitButton.click(() => {
        checkSubmitButtonStatus();
        if (!submitPossible) {
          const $firstRequiredFieldInFormGroupsWithError =
                  $('.form-group.has-error').find('.required-field:first');
          const validationMessages = [];

          $firstRequiredFieldInFormGroupsWithError.each(function () {
            // Check if the current field already has a help block. If it's like that,
            // we can assume, that it contains a more precise message, than the neutral one,
            // we set within this function.
            const currentGroupHasHelpBlock = $(this)
                .closest('.form-group')
                .find('.help-block')
                .length > 0;

            if (!currentGroupHasHelpBlock) {
              validationMessages.push({
                element: $(this).attr('name'),
                texts: [$.i18n._('notification_check_information')],
              });
            }
          });

          currentForm.trigger('sgFramework.forms.validation.set', [validationMessages, throttled]);

          throttled = true;

          window.clearTimeout(validationTimeout);
          /*
           Add a delay so that the scroll-jacking is not
           behaving like crazy on submit button hammering
           */
          validationTimeout = window.setTimeout(() => {
            // Trigger the event to add the validation messages to the form elements
            throttled = false;
          }, 1000);
        }
      });

      currentForm.submit((e) => {
        // abort the real submit
        e.preventDefault();
        e.stopPropagation();
        checkSubmitButtonStatus();
      });

      cvcCodeField.bind('keyup', () => {
        checkSubmitButtonStatus();
      });

      extraFields.bind('keyup change', removeError);
      birthdayFields.bind('change', removeError);
      phoneFields.bind('keyup change', removeError);
      otherRequiredFields.bind('keyup change', removeError);

      // initialize the terms confirmation checkbox if present
      const $checkboxTerms = currentForm.find(':checkbox.terms-confirmation');
      if (typeof window.layoutFeatures === 'undefined' || !window.layoutFeatures.checkoutNew) {
        $checkboxTerms.shopgateUICheckbox().bind('onChange', (e, checkbox) => {
          const isChecked = checkbox.is(':checked');

          // remove the errors if the checkbox is checked by the user
          if (isChecked) {
            removeError(e, checkbox);
          }
        });
      } else {
        $checkboxTerms.click((e) => {
          const isChecked = $checkboxTerms.prop('checked');
          $checkboxTerms.parent('.checkbox-element').toggleClass('checked', isChecked);

          // remove the errors if the checkbox is checked by the user
          if (isChecked) {
            removeError(e, $checkboxTerms);
          }
        });
      }

      if (typeof $.shopgate.modal === 'function') {
        $('#cvc-description').click(() => {
          $.shopgate.modal({
            title: $.i18n._('credit_card_cvc'),
            body: $.i18n._('credit_card_cvc_description'),
          });
        });
      }

      checkCvcCode();
      checkRequiredInputs();
      checkSubmitButtonStatus();
    });
  };

  $.fn.shopgateAjaxFormTypeCart = function () {
    return this.each(function () {
      const currentForm = $(this);
      const cartEntries = currentForm.find('.product-item');
      const checkoutButton = currentForm.find('.cart-checkout-button');
      let buttonsLocked = false;

      // remove the old value from the coupon field
      $('#coupon-input').val('').bind('keydown', function (e) {
        const $that = $(this);
        if (e.which === 13) {
          if ($that.val()) {
            currentForm.submit();
          }
        }
      });

      currentForm.watchFormChanges();

      $('.item-delete, .item-edit, .product-item-change, #coupon-button').addClass('no-sg-action');

      function submitForm() {
        buttonsLocked = true;
        currentForm.submit();
      }

      /**
       * Adds a data attribute to the current form that tells if it can be submitted, or not
       * @param {boolean} disabled Disable or enable submit
       * @private
       */
      function toggleSubmitDisabled(disabled) {
        checkoutButton.toggleClass('disabled', !!disabled);
        currentForm.data('submitDisabled', !!disabled);
      }

      function triggerCartDataUpdate(data) {
        $('footer.hideable').toggleClass('hidden', data.cart.productsCount < 1);
        $(document).trigger('shopgateFramework.dataUpdate.cart', [data]);
      }

      // edit buttons
      currentForm.find('.item-edit').off('click').click((e) => {
        e.preventDefault();
        if (buttonsLocked) {
          return false;
        }

        cartEntries.toggleClass('editable');
        toggleSubmitDisabled(true);

        return true;
      });

      // handle the plus-btn
      currentForm.find('.cart-product-quantity .item-plus').off('click').click(function () {
        if (buttonsLocked) {
          return;
        }
        const $that = $(this);

        $that.parents('.cart-product-quantity')
          .find('.product-item-new-amount')
          .val(
            parseInt(
              $that.parents('.cart-product-quantity').find('.product-item-new-amount').val(),
              10
            ) + 1
          );
      });

      currentForm.find('.cart-product-quantity .product-item-new-amount').on('blur', function () {
        const $that = $(this);
        if ($that.val().length === 0) {
          $that.val($that.data('old-value'));
        }
      });

      // handle the minus-btn
      currentForm.find('.cart-product-quantity .item-minus').off('click').click(function () {
        if (buttonsLocked) {
          return;
        }
        const $that = $(this);
        if ($that.parents('.cart-product-quantity').find('.product-item-new-amount').val() > 0) {
          $that.parents('.cart-product-quantity')
            .find('.product-item-new-amount')
            .val(
              parseInt(
                $that.parents('.cart-product-quantity').find('.product-item-new-amount').val(),
                10
              ) - 1
            );
        }
      });

      // save the quantity of the product in the cart
      currentForm.find('.product-item-change').off('click').click((e) => {
        e.preventDefault();

        if (buttonsLocked) {
          return false;
        }

        function beforeSend() {
          toggleSubmitDisabled(true);
        }

        function complete() {
          toggleSubmitDisabled(false);
        }

        function success(data) {
          if (data.success) {
            triggerCartDataUpdate(data.data);
          }
        }

        if (currentForm.formHasChanged()) {
          if (currentForm.hasClass('ajax-reload')) {
            $.shopgate.ajaxContentUpdate({
              url: currentForm.attr('action'),
              data: currentForm.serialize(),
              beforeSend,
              complete,
              success,
            });
          } else {
            submitForm();
          }
        } else {
          cartEntries.toggleClass('editable');
          toggleSubmitDisabled(false);
        }

        return true;
      });

      currentForm.find('.item-delete').off('click').click(function (e) {
        e.preventDefault();

        if (buttonsLocked) {
          return false;
        }
        const $that = $(this);
        const currentCartEntry = $that.closest('.product-item');
        const currentCartEntrySiblings = currentCartEntry.siblings('.product-item');
        const cartEntriesWrapper = currentForm.find('.product-bundle');
        const animationTarget = currentCartEntrySiblings.length > 0 ?
          currentCartEntry : cartEntriesWrapper;

        function beforeSend() {
          toggleSubmitDisabled(true);
          animationTarget.slideUp();
        }

        function error() {
          animationTarget.slideDown();
        }

        function complete() {
          buttonsLocked = false;
          toggleSubmitDisabled(false);
        }

        function success(data) {
          if (data.success) {
            animationTarget.remove();
            triggerCartDataUpdate(data.data);
          } else {
            animationTarget.slideDown();
          }
        }

        $.shopgate.ajaxContentUpdate({
          url: $(this).prop('href'),
          beforeSend,
          error,
          success,
          complete,
        });

        return true;
      });

      currentForm.find('#coupon-button').off('click').click(function (e) {
        e.preventDefault();

        if (buttonsLocked) {
          return false;
        }

        const $that = $(this);

        if ($('#coupon-input').val()) {
          $that.addClass('disabled loading');
          currentForm.submit();
        }
        return true;
      });

      // has no effect in ios8 template change quantity because of swipify
      currentForm.bind('shopgateFramework.forms.dataUpdate', (e, data) => {
        buttonsLocked = false;
        triggerCartDataUpdate(data.data);
      });
    });
  };


  function initAjaxForms() {
    // add the default ajax-form-submit and ajax-form-validation logic
    $('form[data-form-type="checkout"]').shopgateAjaxFormTypeCheckout();
    $('form[data-form-type="cart"]').shopgateAjaxFormTypeCart();
    $('form[data-form-submit-type="ajax"]').shopgateAjaxFormSubmit();
    $('form[data-form-validation-type="default"]').shopgateAjaxFormValidationDefault();
    if (typeof window.layoutFeatures === 'undefined' || !window.layoutFeatures.checkoutNew) {
      $('form[data-form-type="payment"]').shopgateAjaxFormTypePayment();
      $('form[data-form-type="invoice-address"]').shopgateAjaxFormTypeInvoiceAddress();
      $('form[data-form-type="shipping-address"]').shopgateAjaxFormTypeShippingAddress();
    }
    $('form').shopgateFormHelpers();
  }

  $(document).ready(() => {
    initAjaxForms();
  });

  $(document).bind('shopgateFramework.ui.contentUpdated', () => {
    initAjaxForms();
  });
})();



// WEBPACK FOOTER //
// ./Library/1.0/common/jquery.shopgate-ajax-forms-checkout.js